exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#intouch-footer {\n  position: relative;\n  font-size: 50px;\n  font-weight: 500; }\n\n.packing-logo-bar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/rfid-packing-slip-modal/rfid-packing-slip-modal.component.scss
// module id = ../../../../../src/app/shared/modals/rfid-packing-slip-modal/rfid-packing-slip-modal.component.scss
// module chunks = main